export { default } from './src/loadable-component';